import type { AnalyticsCorrection } from '../../cashier-analytics/model/types'
import type { SalesPoint } from './types'

/** Отказ службы для показа: текст дословно (ADR-8) и код, если он есть. */
export interface SalesPointProblem { message: string; code: string | null }
export const problemText = (problem: SalesPointProblem) => problem.code === null || problem.code === '' ? problem.message : `${problem.message} · Код: ${problem.code}`

export function registersText(count: number): string {
  const last = count % 10, tail = count % 100
  if (last === 1 && tail !== 11) return `${count} касса`
  if (last >= 2 && last <= 4 && (tail < 12 || tail > 14)) return `${count} кассы`
  return `${count} касс`
}

/** Источники магазина по порядку появления, без повторов. */
export const pointSourceNames = (point: SalesPoint) => [...new Set(point.registers.map((register) => register.resourceName))].filter((name) => name !== '')

/** Строка истории: что было или стало в сохранённом JSON группы. */
export function auditDescription(json: string): string {
  try {
    const value: unknown = JSON.parse(json)
    if (typeof value !== 'object' || value === null) return 'Магазина ещё не было'
    const item = value as Record<string, unknown>
    const registers = Array.isArray(item.registers) ? item.registers as { resourceName?: string; registerName?: string }[] : []
    return `${typeof item.name === 'string' ? item.name : ''}${item.archived === true ? ' (в архиве)' : ''}: ${registers.map((register) => `${register.resourceName ?? ''} — ${register.registerName ?? ''}`).join('; ')}`
  } catch { return 'История недоступна' }
}

/** Тип расчёта чека коррекции так, как подписал его источник (незнакомый — кодом дословно); сторно — пометкой (RP-ST17). */
export const correctionSettlementText = (correction: AnalyticsCorrection) =>
  `${correction.settlementLabel ?? correction.settlement}${correction.storno ? ' · сторно' : ''}`

const EXCLUDED_TEXT: Record<string, string> = { 'not-printed': 'не пробит', 'unknown-settlement': 'тип расчёта не распознан' }

/** Вошёл ли чек коррекции в итоги дня: «да» или «нет» с причиной словами; незнакомая причина — кодом дословно. */
export const correctionCountedText = (correction: AnalyticsCorrection) => correction.counted ? 'да'
  : correction.excluded === null ? 'нет' : `нет — ${EXCLUDED_TEXT[correction.excluded] ?? correction.excluded}`
